<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round">
    <path d="M21 8v13H3V8"></path>
    <rect x="1" y="3" width="22" height="5" rx="1"></rect>
    <path d="M10 12h4"></path>
  </svg>
</template>
